// Notifications natives navigateur (Web Notification API).
// Affiche une notification sur le bureau quand l'onglet n'est pas focus
// (ou systématiquement, selon le navigateur).

export type DesktopPermission = NotificationPermission | 'unsupported';

const STORAGE_KEY = 'aq.desktop-notif-asked';

export function isSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

export function getPermission(): DesktopPermission {
  if (!isSupported()) return 'unsupported';
  return Notification.permission;
}

export function hasAskedBefore(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function markAsked(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // ignore (private mode, etc.)
  }
}

export async function requestPermission(): Promise<DesktopPermission> {
  if (!isSupported()) return 'unsupported';
  markAsked();
  try {
    const result = await Notification.requestPermission();
    return result;
  } catch {
    return Notification.permission;
  }
}

interface ShowOptions {
  title: string;
  body?: string;
  icon?: string;
  tag?: string;
  link?: string | null;
  onClick?: () => void;
  silent?: boolean;
}

export function showDesktopNotification(opts: ShowOptions): Notification | null {
  if (!isSupported() || Notification.permission !== 'granted') return null;
  try {
    const notif = new Notification(opts.title, {
      body: opts.body,
      icon: opts.icon || '/vite.svg',
      tag: opts.tag,
      silent: opts.silent,
    });
    notif.onclick = () => {
      window.focus();
      if (opts.onClick) opts.onClick();
      else if (opts.link) window.location.href = opts.link;
      notif.close();
    };
    return notif;
  } catch {
    return null;
  }
}
